import React, { useState, useEffect } from 'react';
import 'swiper/css';
import 'swiper/css/pagination';
import { dateFromMillisecond } from '../config/Configuration';
import Simg from '../images/no-image-257.jpg';
import blackCircle from '../images/blackCircle.jpg';
import axios from '../api/axios';
import {useDispatch } from 'react-redux';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import '../css/Custom.css'
import { toast } from 'react-toastify';
import { fetchAd, myAd } from '../redux/store/actions/adActions';
import { startLoading } from '../redux/store/actions/actionsTypes';
import FollowIcon from '../images/followIcon.png';
import { checkImpressionFunc } from '../config/fbAdImpression';
import { Image } from 'react-bootstrap';


function FacebookAdBox(props) {
    const dispatch = useDispatch();
    const maxLength = 100;
    const [isExpanded, setIsExpanded] = useState(false);
    const record = JSON.parse(props.item.record);
    const publisherPlatform = record ? record.publisherPlatform : '';
    const token = JSON.parse(localStorage.getItem('token'));
    const [impressionData, setImpressionData] = useState([]);
    const [brandImage, setBrandImage] = useState(false);
    const [mediaImage, setMediaImage] = useState(false);
    

    useEffect(() => {
        getData(record);
        loadDefauldMedia();
    }, []);

  

    const loadDefauldMedia = () => {
        let tempBrandImg = '';

        if (props.item.ad_logo) {
            tempBrandImg = process.env.REACT_APP_BACKEND_BASE_URL+'/' + props.item.ad_logo;

        }
        else if (record.snapshot.page_profile_picture_url) {
            tempBrandImg = record.snapshot.page_profile_picture_url;

        }
     
        setBrandImage(tempBrandImg);

        let tempMediaImg = '';

        if (props.item.ad_image) {
            tempMediaImg = process.env.REACT_APP_BACKEND_BASE_URL+'/' + props.item.ad_image;

        }
        else if (props.item.cardResizedImageUrl) {
            tempMediaImg = props.item.cardResizedImageUrl;

        }

        setMediaImage(tempMediaImg);
    };

    async function getData(record) {
    }
    const toggleReadMore = () => {
        setIsExpanded(!isExpanded);
    };

    const onErrorBrandImage = () => {
        setBrandImage(blackCircle);
    };

    const onErrorMediaImage = () => {
        setMediaImage(Simg);
    };

    const handleCheckSpend = async () => {
        const data = await checkImpressionFunc(record);
        setImpressionData(data);
    }

    const handleSaveAd = async (id) => {
        dispatch(startLoading());
        const config = {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        };
        const bodyParameters = {
            id: id
        };
        axios
            .post("/dashboardAds/save", bodyParameters, config)
            .then((response) => {
                if (response.data.status) {
                    toast.success(response.data.message);
                    setTimeout(
                        function () {
                            dispatch(fetchAd());
                            dispatch(myAd());


                        }
                            .bind(this),
                        3000
                    );

                } else {
                    toast.error(response.data.message);
                }
            })
            .catch((err) => {
                toast.error(err.message || "An error occurred. Please try again.");

            });
    };
    const handleUnsaveOrDelete = async (id) => {


        dispatch(startLoading());

        const config = {
            headers: {
                'Authorization': 'Bearer ' + token,
            },
        };
        const bodyParameters = {
            id: id
        };
        axios
            .post("/dashboardAds/save", bodyParameters, config)
            .then((response) => {
                if (response.data.status) {
                    toast.success(response.data.message);
                    setTimeout(
                        function () {
                            dispatch(fetchAd());
                            dispatch(myAd());
                        }
                            .bind(this),
                        3000
                    );

                } else {
                    toast.error(response.data.message);
                }
            })
            .catch((err) => {
                toast.error(err.message || "An error occurred. Please try again.");

            });

    };
    const handleConfirmation = (id) => {
        const action = props.pageName === 'myAds' ? 'delete' : 'unsave';
        const confirmationMessage = `Are you sure you want to ${action} this ad?`;

        confirmAlert({
            customUI: ({ onClose }) => (
                <div className="custom-confirmation-box">
                    <h2 className="confirmation-title">Confirm Action</h2>
                    <p>{confirmationMessage}</p>
                    <div className="confirmation-buttons">
                        <button
                            style={{ backgroundColor: '#09D7A6', color: '#fff' }}
                            onClick={() => {
                                handleUnsaveOrDelete(id);
                                onClose();
                            }}
                        >
                            Yes
                        </button>
                        <button
                            style={{
                                backgroundColor: '#fff',
                                color: '#09D7A6',
                                border: '1px solid #09D7A6',
                            }}
                            onClick={onClose}
                        >
                            No
                        </button>
                    </div>
                </div>
            ),
            overlayClassName: "custom-overlay", 
        });
    };
    const handleFollowToggle = (pageName) => {
        dispatch(startLoading());
        axios
            .post('/toggle-follow', { page_name: pageName }, { headers: { Authorization: `Bearer ${token}` } })
            .then((response) => {
             
                if (response.data.status) {
                    toast.success(response.data.message);
                    setTimeout(
                        function () {
                            dispatch(fetchAd());
                            dispatch(myAd());
                        }
                            .bind(this),
                        3000
                    );

                } else {
                    toast.error(response.data.message);
                }
            })
            .catch(err => {
                toast.error(err.message || "An error occurred. Please try again.");
            });
    };

    return (

        <>
            {(() => {

                if (props.revanueValue == 0 || (impressionData['day'] && impressionData['day'] < props.revanueValue)) {
                    const isPageFollowed = props.followedPages.includes(record?.snapshot?.page_name);
                    return (
                        <>
                            <div className='col-xl-3 col-lg-4 col-md-6 col-sm-12'>
                                <div className='download-media'>
                                <div className='download-media-detail'>
                                    <div className='bookmark-title'><span>Library IDs: {props.item.library_id}</span>  <a
                                        className={props.item.myads.length > 0 ? "bookmark-saved" : ""}
                                        onClick={(e) => props.item.myads.length > 0 ? handleConfirmation(props.item.id) : handleSaveAd(props.item.id)}
                                      >
                                        <i
                                            className={`fa-solid ${props.item.myads.length > 0
                                                    ? props.pageName === 'myAds'
                                                        ? 'fa-trash'
                                                        : 'fa-bookmark'
                                                    : 'fa-bookmark'
                                                }`}
                                        ></i></a>
                                    </div>
                                    <div className='d-media'>
                                        <div className='d-media-left'>
                                            <div className='d-media-active'><i className="fa-solid fa-circle-check"></i>Active</div>
                                            <p style={{minHeight: "0px", marginBottom: "15px"}}>Started running on {dateFromMillisecond(props.item.startDate)} </p>
                                            <div className='d-media-active'>Platform
                                                {publisherPlatform && publisherPlatform.length > 0 ? (
                                                    publisherPlatform.map(socialName => (


                                                        <>

                                                            <i class={'fa-brands fa-' + socialName}></i>

                                                        </>
                                                    ))
                                                ) : ('')}

                                            </div>
                                            <p style={{minHeight: "0px", marginBottom: "15px"}}>This ad has multiple versions   <i className="fa-solid fa-exclamation"></i></p>
                                        </div>
                                        <div className='d-media-right'>
                                            {Object.keys(impressionData).length == 0 ? <button type='button' onClick={handleCheckSpend} class="outline-greenColor-btn views" >Check Spend</button> : ''}
                                            {Object.keys(impressionData).length > 0 ? <>
                                                <span className='views'>{impressionData['views'] ? impressionData['views'] : 0} Views</span>
                                                <span className='views-price'>€{impressionData['spend'] ? impressionData['spend'] : 0}</span>
                                                <span className='views-time'>{impressionData['day'] ? impressionData['day'] : 0}€/ Days</span>
                                            </> : ''}
                                        </div>
                                    </div>
                                        
                                        
                                        
                                    
                                    <div className='sponsered-div justify-content-between align-items-center mb-3 flex-wrap'>
                                        <div className='d-flex'>
                                        {(() => {

                                            return (<>
                                                <img src={brandImage} onError={() => onErrorBrandImage()} alt='sponser' />
                                            </>)

                                        })()}
                                        <div className='sponser-right'>
                                            <div className='sponser-title sponserMain-heading'>{record.snapshot ? record.snapshot.page_name : ''}</div>
                                            <p className='sponserMain-description'>Sponsored</p>
                                        </div></div>
                                        <button 
                                            onClick={() => handleFollowToggle(record?.snapshot?.page_name)}
                                            className="follow-btn"
                                        ><Image src={FollowIcon} alt='img'/>
                                           <span className='text-decoration-underline'>{isPageFollowed ? 'Unfollow' : 'Follow'}</span> 
                                        </button>

                                    </div>
                                </div>
                                    <img className='s-img' src={mediaImage} alt='s-img' onError={() => onErrorMediaImage()} />
                                    <p style={{padding: "17px 17px 0px"}}>
                                        {props.item.cardBody && (
                                            <>
                                            {isExpanded || props.item.cardBody.length <= maxLength
                                                ? props.item.cardBody
                                                : `${props.item.cardBody.substring(0, maxLength)}...`}
                                            
                                            {props.item.cardBody.length > maxLength && (
                                                <button className="readMore-btn" onClick={toggleReadMore}>
                                                {isExpanded ? 'Read Less' : 'Read More'}
                                                </button>
                                            )}
                                            </>
                                        )}
                                    </p>
                                     <div className='profileAddAction-btn'>
                                    <div className="row">
                                        <div className='col-md-6'>
                                        <button 
                                            onClick={() => window.open(record && record.snapshot ? record.snapshot.page_profile_uri : '', '_blank')} 
                                            className="greenColor-btn w-100 mb-3"
                                        >
                                            See Profile
                                        </button>
                                        </div>
                                        <div className='col-md-6'>
                                        <button 
                                            onClick={() => window.open(record && record.snapshot ? record.snapshot.link_url : '', '_blank')} 
                                            className="blackColor-btn w-100 mb-3"
                                        >
                                            Call To Action
                                        </button>
                                        </div>
                                        <div className='col-md-12'>
                                        <button 
                                            onClick={() => window.open(record && record.adArchiveID ? 'https://www.facebook.com/ads/library/?id='+ record.adArchiveID : '', '_blank')} 
                                            className="outline-greenColor-btn w-100 mb-3"
                                        >
                                            See Ad
                                        </button>
                                        </div>
                                    </div></div>
                                </div>
                            </div>
                        </>)
                }
            })()}
        </>
    )
}

export default FacebookAdBox